import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar } from 'recharts';
import Icon from '../../../components/AppIcon';
import { format } from 'date-fns';

const DeliveryTrendsChart = ({ data }) => {
  const chartData = data?.map(stat => ({
    date: format(new Date(stat?.date), 'MMM dd'),
    delivered: stat?.deliveredCount || 0,
    bounced: stat?.bouncedCount || 0,
    failed: stat?.failedCount || 0,
    opened: stat?.openedCount || 0,
    deliveryRate: stat?.deliveryRatePercent || 0
  })) || [];

  return (
    <div className="bg-white/10 backdrop-blur-md rounded-xl shadow-elevation-1 p-6 mb-8 border border-white/20">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-white mb-1">Delivery Trends</h3>
          <p className="text-sm text-gray-300">Email delivery performance over time</p>
        </div>
        <div className="w-10 h-10 bg-[#1FB5A5]/20 rounded-lg flex items-center justify-center">
          <Icon name="TrendingUp" size={20} className="text-[#1FB5A5]" />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Delivery Status Chart */}
        <div>
          <h4 className="text-sm font-semibold text-gray-300 mb-3">Delivery Status Breakdown</h4>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
              <XAxis 
                dataKey="date" 
                stroke="rgba(255,255,255,0.5)"
                style={{ fontSize: '12px' }}
              />
              <YAxis 
                stroke="rgba(255,255,255,0.5)"
                style={{ fontSize: '12px' }}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'rgba(0, 43, 69, 0.95)',
                  border: '1px solid rgba(31, 181, 165, 0.3)',
                  borderRadius: '8px',
                  color: '#fff'
                }}
              />
              <Legend 
                wrapperStyle={{ color: '#fff' }}
              />
              <Bar 
                dataKey="delivered" 
                fill="#10B981" 
                name="Delivered"
                radius={[4, 4, 0, 0]}
              />
              <Bar 
                dataKey="bounced" 
                fill="#F59E0B" 
                name="Bounced"
                radius={[4, 4, 0, 0]}
              />
              <Bar 
                dataKey="failed" 
                fill="#EF4444" 
                name="Failed"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Delivery Rate Trend */}
        <div>
          <h4 className="text-sm font-semibold text-gray-300 mb-3">Delivery Rate & Engagement</h4>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
              <XAxis 
                dataKey="date" 
                stroke="rgba(255,255,255,0.5)"
                style={{ fontSize: '12px' }}
              />
              <YAxis 
                stroke="rgba(255,255,255,0.5)"
                style={{ fontSize: '12px' }}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'rgba(0, 43, 69, 0.95)',
                  border: '1px solid rgba(31, 181, 165, 0.3)',
                  borderRadius: '8px',
                  color: '#fff'
                }}
              />
              <Legend 
                wrapperStyle={{ color: '#fff' }}
              />
              <Line 
                type="monotone" 
                dataKey="deliveryRate" 
                stroke="#1FB5A5" 
                strokeWidth={3}
                name="Delivery Rate (%)"
                dot={{ fill: '#1FB5A5', r: 4 }}
              />
              <Line 
                type="monotone" 
                dataKey="opened" 
                stroke="#A78BFA" 
                strokeWidth={2}
                name="Opened"
                dot={{ fill: '#A78BFA', r: 3 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default DeliveryTrendsChart;